import { apiCall } from './config';

export default {
  getLeadDetailApi: payload => {
    return apiCall(`v1/partnerportal/sfdc/lead/${payload}`, 'GET');
  },
  updateLeadDetail: payload => {
    const { leadId, updatedData } = payload;
    return apiCall(`v1/partnerportal/sfdc/lead/${leadId}`, 'PATCH', {
      body: updatedData
    });
  }
};
